export default {
  examCheck: {},
  examCheckList: [],
}
